module.exports = __webpack_public_path__ + "img/icon_sign_title.37578503.png";